// extracted by mini-css-extract-plugin
export default {"myWss__saveButtonYes":"MyWss_myWss__saveButtonYes__O0Roc","myWss__saveButtonNo":"MyWss_myWss__saveButtonNo__+7B4I","myWss__saveBox":"MyWss_myWss__saveBox__TG5Pt"};